{
  "name": "cta",
  "type": "module",
  "version": "1.10.0",
  "private": true,
  "dependencies": {
    "@openx/component-test-utils": "*",
    "@openx/components-core": "*",
    "@openx/constants": "*",
    "@openx/types": "*",
    "@openx/unit-test-utils": "*",
    "@openx/utils": "*"
  }
}
